import api from './api';

export const workoutService = {
  async getWorkouts(params = {}) {
    const response = await api.get('/trainings', { params });
    return response.data;
  },

  async getWorkoutById(id) {
    const response = await api.get(`/trainings/${id}`);
    return response.data;
  },

  async getCurrentWorkout() {
    const response = await api.get('/workout-progress/current');
    // The API returns { workout, workoutProgress, exercisesProgress }
    return response.data;
  },

  async startWorkout(workoutId) {
    const response = await api.post('/workout-progress/start', { workoutId });
    // Returns { workout, workoutProgress, exercisesProgress }
    // Return the workoutProgress with the workout nested for compatibility
    if (response.data.workoutProgress) {
      return {
        ...response.data.workoutProgress,
        workout: response.data.workout,
        exercisesProgress: response.data.exercisesProgress
      };
    }
    return response.data;
  },

  async completeExercise(workoutProgressId, exerciseData) {
    const response = await api.put(
      `/workout-progress/${workoutProgressId}/exercise/complete`,
      exerciseData
    );
    return response.data;
  },

  async completeWorkout(workoutProgressId) {
    const response = await api.put(`/workout-progress/${workoutProgressId}/complete`);
    return response.data;
  },

  async getWorkoutHistory(params = {}) {
    const response = await api.get('/workout-progress/history', { params });
    return response.data;
  },

  async getProgressSummary() {
    const response = await api.get('/workout-progress/summary');
    return response.data;
  },

  async getCompletedWorkoutIds() {
    const response = await api.get('/workout-progress/history', { params: { limit: 1000 } });
    const completedWorkouts = response.data.items || [];
    return completedWorkouts.filter(w => w.completed).map(w => w.workoutId);
  }
};
